<template>
  <div class="notifications-page">
    <v-row no-gutters class="notifications-row">
      <!-- SIDEBAR (desktop) -->
      <v-col class="notification-tabs-bar" cols="12" sm="4">
        <div class="sidebar-inner">
          <v-list-item-group color="#008fc7" v-model="selectedItem">
            <v-subheader>BUTUH PERSETUJUAN ANDA</v-subheader>
            <v-list-item
              v-for="mod in allCategories"
              :key="mod.key"
              :value="mod.tabIndex"
              class="notification-list-item"
            >
              <v-list-item-content>
                <v-list-item-title style="font-size: 14px">
                  <v-icon style="margin-right: 5%">{{ mod.icon }}</v-icon>
                  <strong>{{ mod.listLabel }}</strong>
                </v-list-item-title>
              </v-list-item-content>
              <div class="notification-list-badge" v-if="hasPending(mod)">
                <v-badge
                  color="red"
                  small
                  :content="mod.key != 'notification' ? moduleData(mod).totalData : moduleData(mod).totalUnread"
                ></v-badge>
              </div>
              <v-list-item-icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-item-group>
        </div>
      </v-col>
      <v-col cols="12" sm="6">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="header">
              <div class="search-box">
                <i class="fas fa-search"></i>
                <input
                  type="text"
                  v-model="searchKeyword"
                  @keyup="searchData"
                  placeholder="Cari nomor pengajuan..."
                />
              </div>

              <div
                class="menu-icon filter-desktop"
                ref="menuIcon"
                :class="{ active: isActive }"
                @click="toggleMenu"
              >
                <span class="filter-text">FILTER</span>
                <div class="hamburger" :class="{ move: isActive }">
                  <div class="bar"></div>
                  <div class="bar"></div>
                  <div class="bar"></div>
                </div>
              </div>

              <div
                ref="filterMenu"
                :class="{ 'filter-menu': true, active: showFilters }"
              >
                <div class="kategoriFilter">
                  <div class="filter-option" @click="toggleFilter('status')">
                    Status
                  </div>
                  <div class="filter-option" @click="toggleFilter('category')">
                    Kategori
                  </div>
                </div>

                <div v-if="showStatusFilters">
                  <div
                    class="filter-item"
                    v-for="filter in statusFilterOptions"
                    :key="filter"
                  >
                    <input
                      type="radio"
                      name="Opsi Filter"
                      :id="filter"
                      :value="filter"
                      @click="applyFilter"
                    />
                    <label :for="filter">{{ filter }}</label>
                  </div>
                </div>

                <div v-if="showCategoryFilters">
                  <div
                    class="filter-item"
                    v-for="(filter, index) in categoryFilterOptions"
                    :key="index"
                  >
                    <input
                      type="radio"
                      name="Opsi Filter"
                      :id="filter.name"
                      :value="filter.name"
                      @click="applyCategoryFilter"
                    />
                    <label :for="filter.name">{{ filter.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </v-col>

          <!-- CATEGORY SWITCHER (mobile) -->
          <!-- Menggantikan v-tabs horizontal yang di layar sempit cuma
           menampilkan sebagian kategori dan butuh scroll untuk sisanya.
           Satu tombol menampilkan kategori aktif, tap untuk buka bottom
           sheet berisi SEMUA kategori + badge sekaligus (tanpa scroll
           horizontal, tap target besar). -->
          <v-col class="notification-category-switcher px-10" cols="12">
            <v-btn
              block
              outlined
              color="#008fc7"
              class="category-switcher-btn"
              @click="showCategorySheet = true"
            >
              <v-icon left>{{ activeModule.icon }}</v-icon>
              <span class="category-switcher-label">{{
                activeModule.listLabel
              }}</span>
              <v-chip
                v-if="hasPending(activeModule)"
                x-small
                color="red"
                text-color="white"
                class="ml-2"
              >
                {{ activeModule.key != 'notification' ? moduleData(activeModule).totalData : moduleData(activeModule).totalUnread }}
              </v-chip>
              <v-spacer></v-spacer>
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>

            <v-bottom-sheet v-model="showCategorySheet">
              <v-sheet class="category-sheet">
                <div class="category-sheet-header">Pilih Kategori</div>
                <v-list>
                  <v-list-item
                    v-for="mod in allCategories"
                    :key="mod.key"
                    :class="{
                      'category-sheet-item--active':
                        selectedItem === mod.tabIndex
                    }"
                    @click="selectCategory(mod)"
                  >
                    <v-list-item-icon>
                      <v-icon>{{ mod.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ mod.listLabel }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="hasPending(mod)">
                      <v-chip small color="red" text-color="white">
                        {{ moduleData(mod).totalData }}
                      </v-chip>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-sheet>
            </v-bottom-sheet>
          </v-col>

          <!-- CONTENT -->
          <v-col class="notification-content" cols="12">
            <div class="background">
              <div class="circle circle-1"></div>
              <div class="circle circle-2"></div>
              <div class="circle circle-3"></div>
              <div class="circle circle-4"></div>
            </div>

            <!-- Satu blok generik menggantikan 7 blok v-if="selectedItem === N"
             yang isinya nyaris identik di file asli. Tab "Semua"
             (allCategories[0]) ikut memakai blok yang sama — bedanya
             cardItems() di bawah menggabungkan data 7 kategori dan
             menandai modul asal tiap item, supaya kartu tetap tampil
             dengan avatar/warna/field yang benar sesuai kategori aslinya. -->
            <div
              v-for="mod in allCategories"
              v-show="selectedItem === mod.tabIndex"
              :key="mod.key"
              class="tab-panel"
            >
              <div v-if="!moduleData(mod).loading" class="tab-panel-inner">
                <template
                  v-if="
                    moduleData(mod).result && moduleData(mod).result.length > 0
                  "
                >
                  <NotificationCard
                    v-for="(entry, idx) in cardItems(mod)"
                    :key="idx"
                    :item="entry.item"
                    :module="entry.module"
                    :title="entry.module.getTitle(entry.item) || '-'"
                    :subtitle="entry.module.getSubtitle(entry.item) || '-'"
                    :status-label="statusLabelFor(entry.module, entry.item)"
                    :status-color="statusColorFor(entry.module, entry.item)"
                    :ribbon="ribbonFor(entry.module, entry.item)"
                    @open="handleCardOpen(mod, entry, idx)"
                    :mod="mod"
                  />
                </template>
                <div v-else class="empty-state">
                  <p>Data tidak ditemukan.</p>
                </div>
              </div>
              <div v-else class="loading-state">
                <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import buildType from '../../../../services/buildType'
import NotificationCard from './NotificationCard.vue'
import {
  NOTIF_MODULE,
  ALL_MODULE,
  NOTIFICATION_MODULES,
  CATEGORY_FILTER_OPTIONS,
  STATUS_FILTER_OPTIONS
} from './notificationModules'

// NB tentang riwayat perubahan komponen ini:
// - Tab "Semua Notifikasi" versi lama (memakai getNotification/
//   loadNotification) dulu markup-nya dinonaktifkan lewat HTML comment di
//   file asli, jadi sempat saya bersihkan sekalian dengan method yang cuma
//   dipakai tab itu (deletePerItem, delete/startDelete/deleteAll, action,
//   disableItem, getListItemClass, handleTouchStart/Move/End, checkMove,
//   handleChange, toggleSearch — masih ada di riwayat git kalau perlu).
// - loadNotification/getNotification SEKARANG AKTIF LAGI sebagai tab
//   "Notifikasi" (NOTIF_MODULE, tabIndex 0, default) — action-nya di
//   notification.js sudah saya isi ulang (sebelumnya di-comment total).
//   openNotification & changeToRead dari store dipakai lagi juga (lihat
//   handleCardOpen), TAPI hanya untuk tab ini — 7 tab kategori lain tetap
//   pakai openNotification2 versi komponen (window.open ke tab baru),
//   sedangkan tab "Notifikasi" pakai router.push (tab yang sama) karena
//   itu perilaku asli action openNotification di store. Ini perbedaan
//   yang disengaja, bukan inkonsistensi yang belum dirapikan.
// - Tab "Semua Pengajuan" (ALL_MODULE, tabIndex 1, gabungan client-side
//   dari 7 kategori) TETAP dipertahankan di samping "Notifikasi" untuk
//   pembanding, sesuai permintaan.

export default {
  name: 'Notifications',
  components: { NotificationCard },
  data: () => ({
    modules: NOTIFICATION_MODULES,
    statusFilterOptions: STATUS_FILTER_OPTIONS,
    categoryFilterOptions: CATEGORY_FILTER_OPTIONS,
    showFilters: false,
    showStatusFilters: false,
    showCategoryFilters: false,
    isActive: false,
    hrsApi: buildType.apiURL('hrs'),
    esanqua: buildType.apiURL('esanqua'),
    build: process.env.VUE_APP_BUILD_TYPE,
    selectedItem: 0,
    searchKeyword: '',
    selectedFilters: [],
    showCategorySheet: false,
    // Flag loading khusus tab "Semua Pengajuan" (client-side merge) —
    // sengaja TIDAK ikut membaca moduleData(m).loading tiap kategori
    // (lihat catatan di getDataFromApi & moduleData). Default true supaya
    // spinner tampil saat initial load. Tab "Notifikasi" TIDAK pakai flag
    // ini — dia punya getter Vuex asli sendiri (getNotification.loading).
    allLoading: true,
    _searchDebounceTimer: null
  }),
  computed: {
    ...mapGetters([
      'getUserProfile',
      'getNotification',
      'getPermissionApprovalNeeds',
      'getLeaveApprovalNeeds',
      'getFpbApprovalNeeds',
      'getRabApprovalNeeds',
      'getCaApprovalNeeds',
      'getPjcaApprovalNeeds',
      'getOvertimeApprovalNeeds'
    ]),
    // Sidebar / bottom sheet / tab-panel menampilkan "Notifikasi" + "Semua
    // Pengajuan" + 7 kategori. `modules` (tanpa 2 tab pertama) tetap
    // dipakai terpisah untuk hal-hal yang butuh daftar kategori yang
    // benar-benar bisa di-fetch (lihat getDataFromApi, moduleData) —
    // NOTIF_MODULE & ALL_MODULE bukan kategori nyata dalam artian itu:
    // NOTIF_MODULE punya getter/action asli sendiri (loadNotification/
    // getNotification), tapi ALL_MODULE datanya cuma gabungan 7 kategori
    // lain, tidak punya getter/action sendiri.
    allCategories() {
      return [NOTIF_MODULE, ALL_MODULE, ...this.modules]
    },
    // Dipakai tombol pemicu bottom sheet di mobile untuk menampilkan
    // kategori yang sedang aktif.
    activeModule() {
      return (
        this.allCategories.find((m) => m.tabIndex === this.selectedItem) ||
        this.allCategories[0]
      )
    }
  },
  watch: {
    async selectedItem(val) {
      this.searchKeyword = ''
      if (val === NOTIF_MODULE.tabIndex || val === ALL_MODULE.tabIndex) {
        // "Notifikasi" & "Semua Pengajuan" sama-sama sudah tersedia dari
        // getDataFromApi() paralel saat mount / saat search — tidak perlu
        // fetch ulang saat sekadar pindah ke salah satu tab ini.
        return
      }
      const mod = this.modules.find((m) => m.tabIndex === val)
      if (mod) {
        await this.getDataFromApi(mod)
      } else {
        this.selectedItem = NOTIF_MODULE.tabIndex
      }
    }
  },
  async mounted() {
    this.setTabs([])
    document.addEventListener('click', this.closeMenuOnClickOutside)
    await this.getDataFromApi()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeMenuOnClickOutside)
    clearTimeout(this._searchDebounceTimer)
  },
  methods: {
    ...mapActions([
      'loadNotification',
      'openNotification',
      'loadPermissionApprovalNeeds',
      'loadLeaveApprovalNeeds',
      'loadFpbApprovalNeeds',
      'loadRabApprovalNeeds',
      'loadCaApprovalNeeds',
      'loadPjcaApprovalNeeds',
      'loadOvertimeApprovalNeeds'
    ]),
    ...mapMutations(['setTabs']),

    // Ambil state getter yang sesuai untuk satu modul, dengan fallback
    // aman supaya template tidak perlu optional-chaining di mana-mana.
    // - mod 'notification': langsung pakai getNotification (getter Vuex
    //   asli, punya loading/result/totalData/totalUnread sendiri).
    // - mod 'all': datanya digabung on-the-fly dari 7 getter kategori
    //   (bukan getter Vuex tersendiri), diurutkan dari yang terbaru.
    //   Loading tab ini memakai `allLoading` (lihat getDataFromApi),
    //   BUKAN menunggu semua flag loading per-kategori — supaya tidak
    //   ikut macet kalau salah satu kategori punya flag loading yang
    //   tidak pernah ke-reset di store-nya.
    moduleData(mod) {
      if (mod.key === 'notification') {
        return this.getNotification || { loading: false, result: [], totalData: 0 }
      }
      if (mod.key === 'all') {
        const merged = []
        this.modules.forEach((m) => {
          const data = this.moduleData(m)
          ;(data.result || []).forEach((item) => {
            merged.push({ ...item, __sourceModuleKey: m.key })
          })
        })
        merged.sort((a, b) => {
          const timeA = a.created_at ? new Date(a.created_at).getTime() : 0
          const timeB = b.created_at ? new Date(b.created_at).getTime() : 0
          return timeB - timeA
        })
        return {
          loading: this.allLoading,
          result: merged,
          totalData: merged.length
        }
      }
      return this[mod.getter] || { loading: false, result: [], totalData: 0 }
    },
    hasPending(mod) {
      const data = this.moduleData(mod)
      return !!(data.result && data.result.length > 0)
    },
    // Pasangan {item, module} yang dipakai v-for kartu.
    // - Tab "Semua Pengajuan": tiap item ditandai modul asalnya (lihat
    //   moduleData) supaya kartunya tampil dengan avatar/warna/judul
    //   sesuai kategori aslinya, bukan tampilan generik.
    // - Tab "Notifikasi": item punya field `module` dari backend (dipakai
    //   juga oleh action openNotification/changeToRead di store) — dipakai
    //   di sini untuk resolve avatar/warna kategori asal, TAPI judul/
    //   subjudul/status tetap pakai resolver NOTIF_MODULE sendiri karena
    //   bentuk datanya beda dari item kategori (lihat catatan di
    //   notificationModules.js).
    cardItems(mod) {
      const data = this.moduleData(mod)
      return (data.result || []).map((item) => {
        if (mod.key === 'all') {
          return {
            item,
            module:
              this.modules.find((m) => m.key === item.__sourceModuleKey) || mod
          }
        }
        if (mod.key === 'notification') {
          const originModule = this.modules.find(
            (m) => m.openModuleValue === item.module
          )
          return {
            item,
            module: {
              ...(originModule || mod),
              getTitle: NOTIF_MODULE.getTitle,
              getSubtitle: NOTIF_MODULE.getSubtitle,
              getStatusLabel: NOTIF_MODULE.getStatusLabel,
              getStatusColor: NOTIF_MODULE.getStatusColor,
              ribbon: null
            }
          }
        }
        return { item, module: mod }
      })
    },
    // Klik kartu di tab "Notifikasi" pakai action `openNotification` dari
    // store (router.push ke tab yang sama + otomatis changeToRead) — BUKAN
    // openNotification2 di bawah (window.open tab baru, tanpa changeToRead)
    // yang tetap dipakai 7 tab kategori lain. Ini perbedaan yang disengaja
    // (lihat NB di atas import), bukan inkonsistensi yang belum dirapikan.
    handleCardOpen(mod, entry, idx) {
      if (mod.key === 'notification') {
        this.openNotification({ data: entry.item, idx })
        return
      }
      this.openNotification2(entry.item, entry.module.openModuleValue, idx)
    },
    selectCategory(mod) {
      this.selectedItem = mod.tabIndex
      this.showCategorySheet = false
    },
    statusLabelFor(mod, item) {
      return mod.getStatusLabel(item, this.statusName) || '-'
    },
    statusColorFor(mod, item) {
      return mod.getStatusColor(item, this.statusColor) || 'black'
    },
    ribbonFor(mod, item) {
      return mod.ribbon ? mod.ribbon(item, this.statusName) : null
    },

    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'NO'
          })
          .then((r) => resolve(r))
      })
    },

    // Mengambil data. Tanpa argumen = initial load, semua modul + notifikasi
    // umum dimuat PARALEL (Promise.all) — di versi asli ini berurutan
    // (await satu-satu di dalam satu fungsi besar), jadi initial load lebih
    // lambat daripada perlu. Dengan argumen `mod` = reload satu kategori saja
    // (dipakai saat pindah tab / saat search).
    //
    // `allLoading` di-set lewat try/finally supaya SELALU balik ke false
    // begitu Promise.all selesai — baik semua kategori berhasil, maupun ada
    // salah satu yang gagal (reject). Awalnya spinner tab "Semua" saya buat
    // dari `this.modules.some(m => moduleData(m).loading)`, tapi itu berarti
    // kalau ada SATU SAJA kategori yang flag `loading`-nya di Vuex store
    // macet true (mis. action-nya gagal tapi lupa reset loading ke false di
    // catch block-nya), tab "Semua" ikut macet loading selamanya walau
    // kategori lain sudah selesai. Flag lokal ini melepas ketergantungan itu.
    async getDataFromApi(mod) {
      const finalKeyword = this.normalizeKeyword()

      if (!mod) {
        this.allLoading = true
        try {
          await Promise.all([
            this.loadNotification({
              keyword: finalKeyword,
              document_status: null,
              module: null
            }),
            ...this.modules.map((m) => this[m.action](finalKeyword))
          ])
        } catch (error) {
          console.error('Error loading notifications:', error)
        } finally {
          this.allLoading = false
        }
        return
      }

      await this[mod.action](finalKeyword)
    },

    // Debounce 350ms supaya tidak fetch API di setiap ketukan keyboard.
    // Catatan: saat tab aktif adalah "Semua" (selectedItem = 0), find()
    // di bawah tidak ketemu match di `this.modules` (karena "Semua" bukan
    // kategori nyata) sehingga `mod` bernilai undefined — getDataFromApi
    // otomatis jatuh ke jalur "tanpa argumen" (refetch semua kategori
    // paralel dengan keyword pencarian), yang justru itu perilaku yang
    // benar untuk search di tab gabungan.
    searchData() {
      clearTimeout(this._searchDebounceTimer)
      this._searchDebounceTimer = setTimeout(async () => {
        try {
          const mod = this.modules.find((m) => m.tabIndex === this.selectedItem)
          await this.getDataFromApi(mod)
        } catch (error) {
          console.error('Error searching data:', error)
        }
      }, 350)
    },

    async applyFilter() {
      const selectedFilter = document.querySelector(
        'input[name="Opsi Filter"]:checked'
      )
      let cekNilai = null

      if (selectedFilter) {
        switch (selectedFilter.value) {
          case 'Draft':
            cekNilai = 0
            break
          case 'Waiting Approval':
            cekNilai = 1
            break
          case 'Canceled':
            cekNilai = -2
            break
          case 'Rejected':
            cekNilai = -1
            break
          case 'Approved':
            cekNilai = 2
            break
          default:
            cekNilai = null
        }
      }

      try {
        await this.loadNotification({
          keyword: this.normalizeKeyword(),
          document_status: cekNilai
        })
      } catch (error) {
        console.error('Error filtering data:', error)
      }
    },

    async applyCategoryFilter() {
      const selectedFilter = document.querySelector(
        'input[name="Opsi Filter"]:checked'
      )
      let cekNilai = null

      if (selectedFilter) {
        switch (selectedFilter.value) {
          case 'Cuti':
            cekNilai = 'leave'
            break
          case 'Izin':
            cekNilai = 'permission'
            break
          case 'FPB':
            cekNilai = 'eCatalogue'
            break
          case 'RAB':
            cekNilai = 'rab'
            break
          case 'CA':
            cekNilai = 'Cash Advance'
            break
          case 'PJCA':
            cekNilai = 'pjca'
            break
          case 'Lembur':
            cekNilai = 'overtime'
            break
          default:
            cekNilai = null
        }
      }

      try {
        await this.loadNotification({
          keyword: this.normalizeKeyword(),
          module: cekNilai
        })
      } catch (error) {
        console.error('Error filtering data:', error)
      }
    },

    toggleMenu() {
      this.showFilters = !this.showFilters
      this.showStatusFilters = false
      this.showCategoryFilters = false
      this.isActive = !this.isActive
    },
    toggleFilter(filterType) {
      if (filterType === 'status') {
        this.showStatusFilters = true
        this.showCategoryFilters = false
      } else if (filterType === 'category') {
        this.showStatusFilters = false
        this.showCategoryFilters = true
      }
    },
    // Menutup panel filter saat klik di luar area filter/menu — di file
    // asli fungsi ini sudah ditulis tapi listener-nya di-comment sehingga
    // tidak pernah aktif (filter menu hanya bisa ditutup dengan klik ulang
    // tombol FILTER). Diaktifkan kembali di sini.
    closeMenuOnClickOutside(event) {
      const menuIcon = this.$refs.menuIcon
      const menu = this.$refs.filterMenu
      if (!menuIcon || !menu) return
      if (!menu.contains(event.target) && !menuIcon.contains(event.target)) {
        this.showFilters = false
        this.isActive = false
      }
    },

    openNotification2(pItem, pModule, idx) {
      let arrItem = null
      if (pModule === 'leave') {
        arrItem = { list: this.getLeaveApprovalNeeds.result }
        this.$store.commit('setLeaveQueue', arrItem)
        setTimeout(() => {
          window.open(`/hr/leave/detail/${pItem.id}?idx=${idx}`, '_blank')
        }, 100)
      } else if (pModule === 'permission') {
        arrItem = { list: this.getPermissionApprovalNeeds.result }
        this.$store.commit('setPermQueue', arrItem)
        setTimeout(() => {
          window.open(`/hr/permission/detail/${pItem.id}?idx=${idx}`, '_blank')
        }, 100)
      } else if (pModule === 'eCatalogue') {
        arrItem = { list: this.getFpbApprovalNeeds.result }
        this.$store.commit('setFpbList', arrItem)
        setTimeout(() => {
          window.open(
            `/e-catalogue/fpb-list/fpb/${pItem.id}?idx=${idx}`,
            '_blank'
          )
        }, 100)
      } else if (pModule === 'Cash Advance') {
        arrItem = { list: this.getCaApprovalNeeds.result }
        this.$store.commit('setPayreqQueue', arrItem)
        setTimeout(() => {
          window.open(
            `/e-catalogue/payreq/detail/${pItem.id}?idx=${idx}`,
            '_blank'
          )
        }, 100)
      } else if (pModule === 'pjca') {
        arrItem = { list: this.getPjcaApprovalNeeds.result }
        this.$store.commit('setPjcaQueue', arrItem)
        setTimeout(() => {
          window.open(
            `/e-catalogue/pjca/detail/${pItem.id}?idx=${idx}`,
            '_blank'
          )
        }, 100)
      } else if (pModule === 'rab') {
        arrItem = { list: this.getRabApprovalNeeds.result }
        this.$store.commit('setRabQueue', arrItem)
        setTimeout(() => {
          window.open(
            `/e-catalogue/rab/detail/${pItem.id}?idx=${idx}`,
            '_blank'
          )
        }, 100)
      } else if (pModule === 'overtime') {
        arrItem = { list: this.getOvertimeApprovalNeeds.result }
        this.$store.commit('setOvertimeQueue', arrItem)
        setTimeout(() => {
          window.open(
            `/hr/overtime/document/detail/${pItem.id}?idx=${idx}`,
            '_blank'
          )
        }, 100)
      }
    },

    // --- Helper status: dipertahankan persis logikanya dari file asli,
    // hanya ditambah fallback '-' supaya tidak pernah return undefined
    // (undefined akan tampil sebagai teks kosong tanpa penjelasan di kartu).
    statusName(val, mod) {
      if (mod === 'leave') {
        switch (val) {
          case -2:
            return 'Canceled'
          case -1:
            return 'Rejected'
          case 0:
            return 'Draft'
          case 1:
          case 2:
            return 'Waiting Approval'
          case 3:
            return 'Approved'
          default:
            return '-'
        }
      }
      if (mod === 'permission') {
        switch (val) {
          case -2:
            return 'Canceled'
          case -1:
            return 'Rejected'
          case 0:
            return 'Draft'
          case 1:
            return 'Waiting Approval'
          case 2:
            return 'Approved'
          default:
            return '-'
        }
      }
      if (mod === 'eCatalogue') {
        switch (val) {
          case -1:
            return 'Rejected'
          case 0:
            return 'Draft'
          case 1:
            return 'Waiting Approval'
          case 2:
            return 'In Progress'
          case 3:
            return 'Close'
          case 4:
            return 'Cancel'
          case 5:
            return 'Pending'
          default:
            return '-'
        }
      }
      if (mod === 'Cash Advance') {
        const statName = [
          'DRAFT',
          'WAITING APPROVAL',
          'IN PROGRESS',
          'PAID',
          'CANCEL',
          'REJECT'
        ]
        return statName[val] || '-'
      }
      if (mod === 'rab') {
        const statName = [
          'DRAFT',
          'WAITING APPROVAL',
          'PENDING',
          'IN PROGRESS',
          'DONE',
          'CANCEL',
          'REJECT'
        ]
        return statName[val] || '-'
      }
      if (mod === 'pjca') {
        const statName = [
          'DRAFT',
          'WAITING APPROVAL',
          'DONE',
          'CANCEL',
          'REJECT'
        ]
        return statName[val] || '-'
      }
      if (mod === 'overtime') {
        const statName = [
          'DRAFT',
          'WAITING APPROVAL',
          'APPROVED',
          'CANCEL',
          'REJECT'
        ]
        return statName[val] || '-'
      }
      return '-'
    },
    statusColor(val, mod) {
      if (mod === 'permission') {
        switch (val) {
          case -2:
          case -1:
            return 'red'
          case 0:
          case 1:
            return '#05668d'
          case 2:
            return 'rgba(0, 223, 7, 255)'
        }
      }
      if (mod === 'leave') {
        switch (val) {
          case -2:
          case -1:
            return 'red'
          case 0:
          case 1:
          case 2:
            return '#05668d'
          case 3:
            return 'rgba(0, 223, 7, 255)'
        }
      }
      if (mod === 'eCatalogue') {
        switch (val) {
          case -2:
          case -1:
            return 'red'
          case 0:
          case 1:
          case 2:
            return '#05668d'
          case 3:
            return 'rgba(0, 223, 7, 255)'
        }
      }
      return 'black'
    },
    normalizeKeyword() {
      if (!this.searchKeyword) return ''
      const normalized = this.searchKeyword
        .split(/[\s\r\n]+/)
        .map((item) => item.trim())
        .filter((item) => item !== '')
        .join(',')
      return normalized.replace(/,+/g, ',').replace(/^,|,$/g, '')
    }
  }
}
</script>

<style lang="scss" scoped>
.notifications-page {
  background: rgba(255, 255, 255, 0.6);
  position: sticky;
  top: 0;
  height: 85vh;
}

.notifications-row {
  font-size: 18px;
  padding: 0;
  margin: 0;
  height: 100%;
}

.sidebar-inner {
  padding: 20px;
}

.notification-list-badge {
  font-size: 12px;
  margin-right: 20px;
}

.notification-category-switcher {
  display: none;
}

.category-switcher-btn {
  border-radius: 12px;
  ::v-deep .v-btn__content {
    width: 100%;
    justify-content: flex-start;
  }
}

.category-switcher-label {
  margin-right: 6px;
  text-transform: none;
  font-weight: bold;
  font-size: 14px;
}

.category-sheet {
  border-radius: 16px 16px 0 0;
  max-height: 70vh;
  overflow-y: auto;
}

.category-sheet-header {
  padding: 16px;
  font-weight: bold;
  font-size: 16px;
  border-bottom: 1px solid #eee;
}

.category-sheet-item--active {
  background-color: #e0f0ff;
}

.header {
  padding: 10px 40px;
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-box {
  position: relative;
  width: 310px;
}

.search-box .fas.fa-search {
  width: 35px;
  height: 35px;
  border-radius: 10%;
  border: 2px solid white;
  padding: 5px;
  color: #c5c4c3;
  cursor: pointer;
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.search-box input[type='text'] {
  width: calc(100% - 20px);
  height: 50px;
  padding: 8px;
  padding-left: 60px;
  border: 3px solid #ccc;
  font-size: 14px;
  color: #333;
  border-radius: 40px;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
}

.search-box input:focus {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  outline: none;
  border-color: #85b7d9;
}

.menu-icon {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 10px;
  border: 2px solid #ccc;
  border-radius: 40px;
  transition: background-color 0.3s ease;
}

.menu-icon:hover {
  background-color: #f0f0f0;
}

.menu-icon.active {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
}

.filter-text {
  margin-right: 15px;
  font-size: 12px;
  font-weight: bold;
  color: #6e6e6e;
}

.hamburger {
  background: #6e6e6e;
  width: 30px;
  height: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border-radius: 50%;
  padding: 5px;
  transition: transform 0.3s ease;
}

.hamburger.move {
  transform: rotate(90deg);
  color: #6c5ce7;
}

.hamburger.move .bar:nth-child(1) {
  transform: translateY(6px) rotate(45deg);
}
.hamburger.move .bar:nth-child(2) {
  opacity: 0;
}
.hamburger.move .bar:nth-child(3) {
  transform: translateY(-6px) rotate(-45deg);
}

.bar {
  width: 50%;
  height: 4px;
  background-color: #fff;
  border-radius: 5px;
  transition: transform 0.5s ease, opacity 0.3s ease;
}

.filter-menu {
  display: none;
  background: linear-gradient(to bottom right, #edeee4, #ffffff);
  border: 2px solid #6b6b6b;
  border-radius: 10px;
  padding: 15px;
  position: absolute;
  top: 70px;
  right: 40px;
  width: 220px;
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  opacity: 0;
  transform: translateY(-20px);
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}

.filter-menu:hover {
  box-shadow: 0px 12px 25px rgba(0, 0, 0, 0.3);
}

.filter-menu.active {
  display: block;
  opacity: 1;
  transform: translateY(0);
}

.filter-item label {
  margin-left: 10px;
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  color: #030000;
  transition: color 0.3s ease-in-out;
  cursor: pointer;
}

.filter-item label:hover {
  color: #636956;
}

.filter-item input[type='checkbox'] {
  margin-right: 10px;
}

.filter-item input[type='checkbox']:checked + label:before {
  content: '\2713';
  display: inline-block;
  font-size: 16px;
  margin-right: 5px;
}

.filter-item input[type='checkbox']:checked + label {
  font-weight: bold;
}

.filter-option {
  color: #fff;
  font-weight: bold;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  padding: 10px 20px;
  margin-bottom: 15px;
  border: none;
  border-radius: 15px;
  text-transform: uppercase;
  letter-spacing: 1px;
  background: #6b6b6b;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  transition: all 0.3s ease;
}

.filter-option:hover {
  transform: translateY(-2px);
  box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.3);
}

.tab-panel {
  height: 80vh;
  overflow: scroll;
  padding: 15px 40px;
}

.tab-panel-inner,
.empty-state,
.loading-state {
  height: 100%;
}

.empty-state,
.loading-state {
  display: flex;
  justify-content: center;
  align-items: center;
}

.empty-state p {
  color: rgba(0, 0, 0, 0.5);
  font-size: 18px;
  font-weight: bold;
  margin: auto;
  text-align: center;
}

.notification-content {
  height: 100%;
  position: relative;
}

.notification-tabs-bar {
  border-radius: 15px;
  display: inline-block;
}

.notification-list-item {
  border-radius: 20px;
  overflow: hidden;
}

.notification-list-item.v-list-item--active {
  background-color: #e0f0ff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
  position: relative;
}

.notification-list-item:not(.v-list-item--active) .v-icon {
  color: #999;
}
.notification-list-item.v-list-item--active .v-icon {
  color: black;
}

@media (max-width: 600px) {
  .notification-tabs-bar {
    display: none;
  }
  .notification-category-switcher {
    display: block;
    margin-top: 10px;
    padding: 0 12px;
  }
  .filter-desktop {
    display: none;
  }
}
</style>
